export const OPEN_CALL_PANEL_EVENT = 'signalbridge:open-call-panel';
export const ADD_HOME_ICON_EVENT = 'signalbridge:add-home-icon';

export function openCallPanel() {
  window.dispatchEvent(new CustomEvent(OPEN_CALL_PANEL_EVENT));
}

export function requestAddHomeIcon() {
  window.dispatchEvent(new CustomEvent(ADD_HOME_ICON_EVENT));
}
